export function OutlineEyeIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 16.0041C14.2096 16.0041 16.0009 14.2127 16.0009 12.003C16.0009 9.79329 14.2096 8.00195 11.9998 8.00195C9.79012 8.00195 7.99878 9.79329 7.99878 12.003C7.99878 14.2127 9.79012 16.0041 11.9998 16.0041Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.0016C4.51119 6.37473 8.0709 4 12 4C15.9291 4 19.4888 6.37473 21 10.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14.002C4.51119 17.6288 8.0709 20.0036 12 20.0036C15.9291 20.0036 19.4888 17.6288 21 14.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99469 10.9996C10.5458 10.9996 10.9926 10.5529 10.9926 10.0018C10.9926 9.45067 10.5458 9.00391 9.99469 9.00391C9.44359 9.00391 8.99683 9.45067 8.99683 10.0018C8.99683 10.5529 9.44359 10.9996 9.99469 10.9996Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
